import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { PrintIcon, PrintOnlineIcon } from "../../../Icons/icons.component";
import SingleFeedItem from "./SingleFeedItem";
import Sticky from "react-sticky-el";
import SingleSocialFeedItem from "../Social/SingleSocialFeedItem";
import BlogsAndForumFeedItem from "../BlogAndForum/BlogsAndForumFeedItem";
import { Badge, Button } from "react-bootstrap";
import {
  LANGUAGE_CODES,
  SOCIAL_PERPAGE_LIMIT,
  SOCIAL_PAGE_PERPAGE_LIMIT,
  PRINT_PERPAGE_LIMIT,
  ONLINE_PERPAGE_LIMIT,
  VERTICALS,
  CONSTANTS,
  HTTP_CODES,
  MAX_FEEDS_LIMIT,
  DATE_FORMATS,
  FEEDS_API_RETRY_LIMIT,
  FEEDS_API_INITIAL_TIME_INTERVAL,
} from "../../../../constants/app-constant";
import VerticalTag from "../../../Shared/VerticalTag";
import { httpGet, httpPost } from "../../../../utility/requestHelper";
import {
  envConfig,
  unifiedEnvConfig,
} from "../../../../constants/api-endpoint";
import Loader from "../../../Shared/Loader";
import {
  arrayToString,
  formatArticleIdentifier,
  formatDate,
  getKeyByValue,
  getSocialApiDateFormat,
  orderByCityList,
} from "../../../../utility/common-methods";
import { REQUEST_CANCELLING_CONSTANTS } from "../../../../constants/cancel-request-constants";
import {
  fetchPrintFeedsByEntity,
  fetchNewPrintFeedsByEntity,
  fetchNewPrintFeedsByEntityParams,
} from "../../../../actions/print-feeds-action";
import { useRef } from "react";

export default function TopicWiseNewsContainer({
  listContainerRef,
  entityFeeds = {},
  activeKey,
  setActiveKey,
  allArticleList,
  onFeedSelect,
  listkey,
  selectedFeeds,
  selectedFeedsGroup,
  handleFeedGroupClick,
  isSocial,
  isBlogsAndForum,
  isPrintAndOnline,
  updatedBulkSentiment,
  updatedBulkTheme,
  updatedBulkFavourite,
  toDate,
  fromDate,
  forEmbedArticles,
  clientId,
  mergePaginatedFeedsToCurrentList,
  onSingleFeedSelect,
  socialFilters,
  setIsSelectAll,
  setSelectedType,
  updateSelectedTagsToFeeds,
  showInfluencerPosts,
  embeddedArticleFilters,
  currentEntityName,
  filters,
  selectedClientId,
  customParams,
  startRange,
  endRange,
  applyFilters = false,
  setApplyFilters,
  isTV,
  tagsApplied,
  updateFeedObjList,
  responseEntityWithCount,
  isDownloadreport,
  isMainstreammedia
}) {
  const {
    entityId,
    entityName,
    printData,
    onlineData,
    socialData,
    blogsAndForumData,
    type,
    tvData,
    DownloadreportData,
    url,
  } = entityFeeds;
  const {
    channelType,
    selectCity,
    tonality,
    isFavouriteChecked,
    countFilters,
    selectedTaglist,
    keyword,
    headline,
    language,
    country,
  } = socialFilters || {};

  const PRINT = "Print";
  const ONLINE = "Online";

  const onlineEleRef = useRef(null);
  const printEleRef = useRef(null);
  const reportEleRef = useRef(null);
  const tvEleRef = useRef(null);
  const socialEleRef = useRef(null);
  const blogsnForumEleRef = useRef(null);
  // debugger;

  const [offset, setOffset] = useState(1);
  const [printOffset, setprintOffset] = useState(0);
  const [onlineOffset, setonlineOffset] = useState(0);
  const [currentData, setCurrentData] = useState([]);
  const [currentEntityData, setCurrentEntityData] = useState(currentEntityName);
  const [isLoading, setIsLoading] = useState(false);
  const [showShowPagination, setShowPagination] = useState(true);
  const [allArticlesDataSet, setAllArticlesDataSet] = useState([]);
  const [printFeedsList, setPrintFeedsList] = useState([]);
  const [onlineFeedsList, setOnlineFeedsList] = useState([]);
  const [feedListLoader, setFeedListLoader] = useState(true);
  const [printDataCount, setPrintDataCount] = useState();
  const [uniquePrintDataCount, setUniquePrintDataCount] = useState();
  const [onlineDataCount, setOnlineDataCount] = useState();
  const [hasMoreSocialFeeds, setHasMoreSocialFeeds] = useState(true);
  const [hasMorePrintOnlineFeeds, sethasMorePrintOnlineFeeds] = useState(true);
  // const [showOnlineFeeds, setShowOnlineFeeds] = useEffect(true);
  // const [showPrintFeeds, setShowPrintFeeds] = useEffect(true);
  const printIdentifier = `print-${listkey}`;
  const onlineIdentifier = `online-${listkey}`;
  const socialIdentifier = `social-${listkey}`;
  const blogsAndForumIdentifier = `blogsAndForum-${listkey}`;
  const isTVIdentifier = `isTVIdentifier-${listkey}`;
  const isReportIdentifier = `isReportIdentifier-${listkey}`;
  const { V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE_OLD } = VERTICALS;
  const isPrintSelected = filters && filters.media_type.indexOf(V_PRINT) !== -1;
  const isOnlineSelected =
    filters && filters.media_type.indexOf(V_ONLINE) !== -1;
  const isBothSelected = (isOnlineSelected && isPrintSelected) || (filters && filters.media_type.indexOf(V_PRINT_AND_ONLINE_OLD) !== -1);

  const parentClientId = useSelector(
    (state) => state.entityAndKeyWordsReducer.parentClientId
  );

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  useEffect(() => {
    if (listkey === 1) {
      if (printData && Object.keys(printData).length) {
        setActiveKey(printIdentifier);
      } else if (socialData && socialData.length) {
        setActiveKey(socialIdentifier);
      } else if (blogsAndForumData && blogsAndForumData.length) {
        setActiveKey(blogsAndForumIdentifier);
      } else if (tvData && tvData.length) {
        setActiveKey(isTVIdentifier);
      } else if (isDownloadreport) {
        setActiveKey(isReportIdentifier);
      }
    }
    // setCurrentData(isBlogsAndForum ? blogsAndForumData : socialData);
    if (isTV) {
      setCurrentData(isTV && tvData);
    }
    if (isDownloadreport) {
      setCurrentData(DownloadreportData);
    }
  }, [
    printData,
    onlineData,
    socialData,
    blogsAndForumData,
    tvData,
    DownloadreportData,
  ]);

  const { TOTAL_ARTICLES, UNIQUE_ARTICLES } = CONSTANTS;

  useEffect(() => {
    setprintOffset(0)
    setonlineOffset(0)
  },[activeKey])

  useEffect(() => {
    if (offset > 1) {
      handleMoreClick();
    }
  }, [offset]);

  useEffect(() => {
    if (printOffset > 1) {
      const identifier = printIdentifier;
      handlePrintOnlineCardMore(undefined,identifier,printEleRef,currentEntityData,V_PRINT);
    }
  }, [printOffset]);
  useEffect(() => {
    if (onlineOffset > 1) {
      const identifier = onlineIdentifier;
      handlePrintOnlineCardMore(undefined,identifier,onlineEleRef,currentEntityData,V_ONLINE);
    }
  }, [onlineOffset]);

  useEffect(() => {
    setFeedListLoader(true);
    setAllArticlesDataSet([]);
    setPrintFeedsList([]);
    setOnlineFeedsList([]);
    setOnlineDataCount(0);
    setPrintDataCount(0);
    setUniquePrintDataCount(0);
    populateFeedByResponse(responseEntityWithCount);
  }, [responseEntityWithCount]);

  useEffect(() => {
    setCurrentEntityData(currentEntityName);
  }, [currentEntityName]);

  // useEffect(() => {
  //   if (currentEntityData && currentEntityData.id) {
  //     getFeedsByEntity();
  //     console.log("one");
  //   }
  // }, [currentEntityData]);
  useEffect(() => {
    if (startRange && endRange) {
      setFeedListLoader(true);
    }
  }, [startRange, endRange]);

  useEffect(() => {
    if (applyFilters) {
      setFeedListLoader(true);
    }
  }, [applyFilters]);

  const getCorrectPublication = () => {
    const { publication } = filters;
    if (!publication) {
      return [];
    }
    if (Array.isArray(publication) && publication.length) {
      return publication.map((p) => p.id);
    }
    return publication.id ? [publication.id] : [];
  };

  const getCorrectVertical = () => {
    const { media_type } = filters;
    const isPrintSelected = media_type.indexOf(V_PRINT) !== -1;
    const isOnlineSelected = media_type.indexOf(V_ONLINE) !== -1;
    const isBothSelected = isOnlineSelected && isPrintSelected;
    if (isBothSelected) {
      return V_PRINT_AND_ONLINE_OLD;
    }
    if (isOnlineSelected) {
      return V_ONLINE;
    }
    if (isPrintSelected) {
      return V_PRINT;
    }
  };

  const getCorrectedReporter = () => {
    const { reporter } = filters;
    if (Array.isArray(reporter)) {
      return arrayToString(reporter.map((e) => e && e.text));
    }
    if (reporter && reporter.text) {
      return reporter.text;
    } else return "";
  };

  const formatData = (data) => {
    try {
      let allArticleIdentifier = [];
      let newTopicData = [];
      Object.keys(data).forEach((topic) => {
        const topicData = data[topic];
        const { Print = [], Online = [] } = topicData;
        newTopicData = topicData;
        const groupedPrintData = {};
        Print.forEach((d) => {
          const { headline, publication_id, publish_date } = d;
          const str = `${headline
            .toString()
            .trim()
            .toLowerCase()}_${publication_id}_${formatDate(
            publish_date,
            DATE_FORMATS.DDMMYYYY_dash
          )}`;
          groupedPrintData[str] = groupedPrintData[str]
            ? [...groupedPrintData[str], d]
            : [d];
        });
        let newGrpdPrintData = {};
        Object.keys(groupedPrintData).forEach((pData) => {
          let currentData = groupedPrintData[pData];
          currentData = orderByCityList(currentData);
          const currentDataIdentifiers = formatArticleIdentifier(
            currentData[0]
          );
          allArticleIdentifier.push(currentDataIdentifiers);
          newGrpdPrintData[pData] = currentData;
        });
        newTopicData = {
          TotalPrintArticles: topicData.print_total !== undefined?topicData.print_total:topicData['Print']?.length,
          TotalOnlineArticles: topicData.online_total !== undefined?topicData.online_total:topicData["Online"]?.length,
          TotalUniquePrintArticles: topicData.print_unique,
          Print: groupedPrintData,
          Online,
        };
        const onlineArticleIdentifier = Online.map((e) =>
          formatArticleIdentifier(e)
        );
        allArticleIdentifier = [
          ...allArticleIdentifier,
          ...onlineArticleIdentifier,
        ];
        // newData[topic] = newTopicData;
      });
      return { formattedData: newTopicData, allArticleIdentifier };
    } catch (e) {
      return {
        formattedData: {},
        allArticleIdentifier: [],
      };
    }
  };

  //change of feed display data based on response from index.js getFeedsByEntity function
  const populateFeedByResponse = (response) => {
    const currentEntityName = response && currentEntityData.entity_name;
    setFeedListLoader(false);
    const currentEntityObj = {};
    if (response && response.hasOwnProperty(currentEntityName)) {
      //formats and extracts data from response that matches formatData parameter type
      currentEntityObj[currentEntityName] = response[currentEntityName];
      const formattedList =
        response &&
        response.hasOwnProperty(currentEntityName) &&
        formatData(currentEntityObj);
      if (formattedList) {
        setPrintFeedsList(formattedList.formattedData[PRINT]);
        setOnlineFeedsList(formattedList.formattedData[ONLINE]);
        setPrintDataCount(formattedList.formattedData["TotalPrintArticles"]);
        setOnlineDataCount(formattedList.formattedData["TotalOnlineArticles"]);
        setUniquePrintDataCount(
          formattedList.formattedData["TotalUniquePrintArticles"]
        );
        setAllArticlesDataSet(formattedList.allArticleIdentifier);
      }
    }
  };

  // getFeedsByEntity moved to index.js as part of CP-106

  const handleCardClick = (e, id, ref, feed, isTVPage) => {
    setIsLoading(true);
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (id === activeKey) {
      setActiveKey(-1);
    } else {
      setActiveKey(id);
      if (ref && listContainerRef) {
        setTimeout(() => {
          const scrollOffset = +ref.current.offsetTop;
          // console.log("scrollOffset", scrollOffset);
          // listContainerRef.current.scrollTo(0, scrollOffset);
          listContainerRef.current.scrollTo({
            top: scrollOffset,
            left: 0,
            behavior: "smooth",
          });
        }, 500);
      }
      if (!isTVPage) {
        httpGet(getViewMoreUrl())
          .then((response) => {
            const {
              data: {
                data,
                pagination: { page, pages },
              },
            } = response;
            if (data && page && pages) {
              const moreData = Object.values(data);
              const allDatas = [...currentData, ...moreData];
              var valueArr = allDatas.map(function (item) {
                return item.id;
              });
              const allData = allDatas.filter(
                (c, i) => valueArr.indexOf(c.id) === i
              );
              setCurrentData(allData);
              setHasMoreSocialFeeds(moreData.length === (isSocial?SOCIAL_PAGE_PERPAGE_LIMIT:50));
              mergePaginatedFeedsToCurrentList(allData, entityId, type);
              setShowPagination(page != pages);
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setOffset(offset - 1);
          })
          .finally(() => setIsLoading(false));
      }
      handleOnAccordianClick(id);
    }
  };

  const handleCardClickSocialBlogCheckbox = (
    e,
    id,
    ref,
    isCardSelected,
    identifier,
    entityId,
    entityName,
    type,
    isBlog
  ) => {
    if (isCardSelected) {
      handleFeedGroupClick(identifier);
      isBlog
        ? onFeedSelect(!isCardSelected, currentData, entityId, type, entityName)
        : onFeedSelect(
            !isCardSelected,
            currentData,
            entityId,
            entityName,
            type
          );
      return false;
    }
    setIsLoading(true);
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    httpGet(getViewMoreUrl())
      .then((response) => {
        const {
          data: {
            data,
            pagination: { page, pages },
          },
        } = response;
        if (data && page && pages) {
          const moreData = Object.values(data);

          const allDatas = [...currentData, ...moreData];
          var valueArr = allDatas.map(function (item) {
            return item.id;
          });
          const allData = allDatas.filter(
            (c, i) => valueArr.indexOf(c.id) === i
          );

          setCurrentData(allData);
          setHasMoreSocialFeeds(moreData.length === (isSocial?SOCIAL_PAGE_PERPAGE_LIMIT:50));
          mergePaginatedFeedsToCurrentList(allData, entityId, type);
          setShowPagination(page != pages);
          handleFeedGroupClick(identifier);
          isBlog
            ? onFeedSelect(!isCardSelected, allData, entityId, type, entityName)
            : onFeedSelect(
                !isCardSelected,
                allData,
                entityId,
                entityName,
                type
              );
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setOffset(offset - 1);
      })
      .finally(() => setIsLoading(false));
  };

  const handlePrintOnlineCardClick = (e, id, ref, feed, type = 0) => {
    setIsLoading(true);
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (id === activeKey) {
      setActiveKey(-1);
    } else {
      setActiveKey(id);
      if (ref && listContainerRef) {
        setTimeout(() => {
          const scrollOffset = +ref.current?.offsetTop;
          // console.log("scrollOffset", scrollOffset);
          // listContainerRef.current.scrollTo(0, scrollOffset);
          listContainerRef.current.scrollTo({
            top: scrollOffset,
            left: 0,
            behavior: "smooth",
          });
        }, 500);
      }
      const isCardSelected = isFeedGroupSelected(id);
      let data = {
        client_id: selectedClientId,
        entity: [feed.id],
        range: {
          start: startRange,
          end: endRange,
        },
        publication_type: filters.publication_type
          ? filters.publication_type
          : null,
        publication_id: getCorrectPublication(),
        edition_ids: filters && filters.edition ? filters.edition : null,
        zone: filters && filters.zone ? [filters.zone] : "",
        tonality: filters.tonality ? filters.tonality : null,
        headline: filters.headline && arrayToString(filters.headline),
        keywords: filters.keywords && arrayToString(filters.keywords),
        client: filters.client ? filters.client : null,
        category: filters.category && arrayToString(filters.category, false),
        vertical: type === 0?getCorrectVertical():type,
        source_type: filters.source_type ? filters.source_type : null,
        reporter: getCorrectedReporter(),
        press_release: filters.press_release ? filters.press_release : null,
        offset: (type === V_PRINT?printOffset:onlineOffset),
        limit: (type === V_PRINT?PRINT_PERPAGE_LIMIT:ONLINE_PERPAGE_LIMIT),
        favourite: filters.favourite ? filters.favourite : null,
        pagination : isCardSelected?0:1,
        
      };
      if(selectedClientId.toString() == "11717"){
        data.languages = filters.languages
      }
      httpPost(
        envConfig.NEW_PRINT_NEWS_TO_ENTITY_LIST,
        fetchNewPrintFeedsByEntityParams(data)
      )
        .then((response) => {
          if((Array.isArray(response.data.result.data) && response.data.result.data.length) || (typeof response.data.result.data == 'object' && Object.keys(response.data.result.data).length)){
            const formattedList = formatData(response.data.result.data);
            setPrintFeedsList(formattedList.formattedData[PRINT]);
            setOnlineFeedsList(formattedList.formattedData[ONLINE]);
            sethasMorePrintOnlineFeeds((type === V_PRINT?PRINT_PERPAGE_LIMIT:ONLINE_PERPAGE_LIMIT) === (type == V_PRINT?formattedList.formattedData.TotalPrintArticles:(type == V_ONLINE?formattedList.formattedData.TotalOnlineArticles:500)))
            setShowPagination((type == V_PRINT?formattedList.formattedData.TotalPrintArticles:(type == V_ONLINE?formattedList.formattedData.TotalOnlineArticles:0)) > 0);
          }
        })
        .catch((error) => {
          console.log(error);
          if(type === V_PRINT){
            setprintOffset(printOffset - (printOffset < PRINT_PERPAGE_LIMIT?0:PRINT_PERPAGE_LIMIT));
            setonlineOffset(0)
          }
          else if(type === V_ONLINE){
            setonlineOffset(onlineOffset - (onlineOffset < ONLINE_PERPAGE_LIMIT?0:ONLINE_PERPAGE_LIMIT));
            setprintOffset(0)
          }
        })
        .finally(() => setIsLoading(false));

      handleOnAccordianClick(id);
    }
  };

  const handlePrintOnlineCardMore = (e, id, ref, feed, type = 0) => {
    setIsLoading(true);
      let data = {
        client_id: selectedClientId,
        entity: [feed.id],
        range: {
          start: startRange,
          end: endRange,
        },
        publication_type: filters.publication_type
          ? filters.publication_type
          : null,
        publication_id: getCorrectPublication(),
        edition_ids: filters && filters.edition ? filters.edition : null,
        zone: filters && filters.zone ? [filters.zone] : "",
        tonality: filters.tonality ? filters.tonality : null,
        headline: filters.headline && arrayToString(filters.headline),
        keywords: filters.keywords && arrayToString(filters.keywords),
        client: filters.client ? filters.client : null,
        category: filters.category && arrayToString(filters.category, false),
        vertical: type === 0?getCorrectVertical():type,
        source_type: filters.source_type ? filters.source_type : null,
        reporter: getCorrectedReporter(),
        press_release: filters.press_release ? filters.press_release : null,
        offset: (type === V_PRINT?printOffset:onlineOffset),
        limit: (type === V_PRINT?PRINT_PERPAGE_LIMIT:ONLINE_PERPAGE_LIMIT),
        favourite: filters.favourite ? filters.favourite : null,
        pagination : 1
      };
      httpPost(
        envConfig.NEW_PRINT_NEWS_TO_ENTITY_LIST,
        fetchNewPrintFeedsByEntityParams(data)
      )
        .then((response) => {
          const formattedList = formatData(response.data.result.data);
          if(type === V_PRINT){
            setPrintFeedsList({...printFeedsList,...formattedList.formattedData[PRINT]});
          }
          else if(type === V_ONLINE){
            setOnlineFeedsList([...onlineFeedsList,...formattedList.formattedData[ONLINE]]);
          }
          sethasMorePrintOnlineFeeds((type === V_PRINT?PRINT_PERPAGE_LIMIT:ONLINE_PERPAGE_LIMIT) === (type == V_PRINT?formattedList.formattedData.TotalPrintArticles:(type == V_ONLINE?formattedList.formattedData.TotalOnlineArticles:500)))
          setShowPagination((type == V_PRINT?formattedList.formattedData.TotalPrintArticles:(type == V_ONLINE?formattedList.formattedData.TotalOnlineArticles:0)) > 0);
        })
        .catch((error) => {
          console.log(error);
          if(type === V_PRINT){
            setprintOffset(printOffset - (printOffset < PRINT_PERPAGE_LIMIT?0:PRINT_PERPAGE_LIMIT));
            setonlineOffset(0)
          }
          else if(type === V_ONLINE){
            setonlineOffset(onlineOffset - (onlineOffset < ONLINE_PERPAGE_LIMIT?0:ONLINE_PERPAGE_LIMIT));
            setprintOffset(0)
          }
        })
        .finally(() => setIsLoading(false));
      // handleOnAccordianClick(id);
  };

  const handlePrintOnlineCardClickCheckBox = (
    e,
    id,
    ref,
    feed,
    isCardSelected,
    entityName,
    identifier,
    printOronline,
    type = 0
  ) => {
    setIsLoading(true);
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    let data = {
      client_id: selectedClientId,
      entity: [feed.id],
      range: {
        start: startRange,
        end: endRange,
      },
      publication_type: filters.publication_type
        ? filters.publication_type
        : null,
      publication_id: getCorrectPublication(),
      edition_ids: filters && filters.edition ? filters.edition : null,
      zone: filters && filters.zone ? [filters.zone] : "",
      tonality: filters.tonality ? filters.tonality : null,
      headline: filters.headline && arrayToString(filters.headline),
      keywords: filters.keywords && arrayToString(filters.keywords),
      client: filters.client ? filters.client : null,
      category: filters.category && arrayToString(filters.category, false),
      vertical: type === 0?getCorrectVertical():type,
      source_type: filters.source_type ? filters.source_type : null,
      reporter: getCorrectedReporter(),
      press_release: filters.press_release ? filters.press_release : null,
      offset: offset,
      limit: SOCIAL_PERPAGE_LIMIT,
      favourite: filters.favourite ? filters.favourite : null,
    };
    httpPost(
      envConfig.NEW_PRINT_NEWS_TO_ENTITY_LIST,
      fetchNewPrintFeedsByEntityParams(data)
    )
      .then(async (response) => {
        const formattedList = formatData(response.data.result.data);
        setShowPagination((type == V_PRINT?formattedList.formattedData.TotalPrintArticles:(type == V_ONLINE?formattedList.formattedData.TotalOnlineArticles:0)) > 0);
        await setPrintFeedsList(formattedList.formattedData[PRINT]);
        await setOnlineFeedsList(formattedList.formattedData[ONLINE]);
        await handleFeedGroupClick(identifier);
        sethasMorePrintOnlineFeeds(false)
        printOronline === "print"
          ? await onFeedSelect(
              !isCardSelected,
              Object.values(formattedList.formattedData[PRINT]).flat(),
              null,
              entityName
            )
          : await onFeedSelect(
              !isCardSelected,
              formattedList.formattedData[ONLINE]
            );
      })
      .catch((error) => {
        console.log(error);
        if(type === V_PRINT){
          setprintOffset(0);
        }
        else if(type === V_ONLINE){
          setonlineOffset(0);
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleOnAccordianClick = (id, index) => {
    setActiveKey(activeKey == id ? null : id);
    const targetElm = document.getElementById(id);
    const scrollElement = document.querySelector(".accordionListWrap");
    if (targetElm && scrollElement) {
      // const position = targetElm.getBoundingClientRect().top || 0;
      // setTimeout(() => {
      //   scrollElement.scrollTo({
      //     top: position - (120 - 20 * index),
      //     behavior: "smooth",
      //   });
      // }, 1000);
    } else {
    }
  };

  const isFeedGroupSelected = (gid) => {
    return selectedFeedsGroup && selectedFeedsGroup.indexOf(gid) !== -1;
  };

  const printFeeds = () => {
    const identifier = printIdentifier;
    const activeClass = activeKey === identifier ? "show" : "";
    const isCardSelected = isFeedGroupSelected(identifier);
    const uniqueArticles = printFeedsList ? Object.keys(printFeedsList) : [];
    if (currentEntityData && Object.keys(currentEntityData).length) {
      return (
        <div
          ref={printEleRef}
          className={
            activeKey !== identifier
              ? "customAccordionRow card"
              : "customAccordionRow card active"
          }
        >
          <Sticky
            scrollElement=".accordionListWrap"
            boundaryElement=".customAccordionRow"
            style={{ position: "relative" }}
            hideOnBoundaryHit={false}
          >
            <div className={`card-header ${activeClass}`}>
              <label className="inputWrap">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    handlePrintOnlineCardClickCheckBox(
                      e,
                      identifier,
                      printEleRef,
                      currentEntityData,
                      isCardSelected,
                      entityName,
                      printIdentifier,
                      "print",
                      V_PRINT
                    );
                  }}
                  checked={isCardSelected}
                />
                <span class="checkmark"></span>
              </label>
              <div className="printBadge printOnlineBadge">
                <PrintIcon />
                <span>Print</span>
              </div>
              <button
                onClick={(e) => {
                  handlePrintOnlineCardClick(
                    e,
                    identifier,
                    printEleRef,
                    currentEntityData,
                    V_PRINT
                  );
                }}
                id={identifier}
                type="button"
                className="btn btn-link"
                disabled={feedListLoader}
              >
                {`${currentEntityData.entity_display_name} ${UNIQUE_ARTICLES}(${
                  uniquePrintDataCount ?? 0
                }) ${TOTAL_ARTICLES}(${printDataCount ?? 0})`}
              </button>
              {/* Please work on this loader */}
              {feedListLoader ? <Loader /> : null}
            </div>
          </Sticky>
          <div className={`collapse ${activeClass}`}>
            <div className="card-body">
              <div className="inner-feed-container">
                {uniqueArticles.map((news, index) => {
                  if (!news) {
                    return null;
                  }
                  let singleNewsGroup = orderByCityList(printFeedsList[news]);
                  const singleNews = singleNewsGroup && singleNewsGroup[0];
                  const editionList =
                    singleNewsGroup &&
                    singleNewsGroup.map((el) => el && el.edition);
                  return (
                    <div class="innerFeedItem" ref={lastPrintOnlineFeedItemElementRef}>
                      <SingleFeedItem
                        key={index}
                        isPrint
                        feed={singleNews}
                        editionList={editionList}
                        allArticleList={allArticlesDataSet}
                        onFeedSelect={onFeedSelect}
                        singleNewsGroup={singleNewsGroup}
                        selectedFeeds={selectedFeeds}
                        updatedBulkTheme={updatedBulkTheme}
                        updatedBulkSentiment={updatedBulkSentiment}
                      />
                      </div>
                  );
                })}
              </div>
            </div>
            {renderPrintOnlinePagination(isCardSelected, null, entityFeeds.total,true)}
          </div>
        </div>
      );
    }
  };

  const onlineFeeds = () => {
    const identifier = onlineIdentifier;
    const isCardSelected = isFeedGroupSelected(identifier);
    const activeClass = activeKey === identifier ? "show" : "";
    const uniqueArticles = onlineFeedsList ? Object.keys(onlineFeedsList) : [];
    if (currentEntityData && Object.keys(currentEntityData).length) {
      return (
        <div
          ref={onlineEleRef}
          className={
            activeKey !== identifier
              ? "customAccordionRow card"
              : "customAccordionRow card active"
          }
        >
          <Sticky
            scrollElement=".accordionListWrap"
            boundaryElement=".customAccordionRow"
            style={{ position: "relative" }}
            hideOnBoundaryHit={false}
          >
            <div className={`card-header ${activeClass}`}>
              <label className="inputWrap">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    handlePrintOnlineCardClickCheckBox(
                      e,
                      identifier,
                      onlineEleRef,
                      currentEntityData,
                      isCardSelected,
                      entityName,
                      onlineIdentifier,
                      "online",
                      V_ONLINE
                    );
                  }}
                  checked={isCardSelected}
                />
                <span className="checkmark"></span>
              </label>
              <div className="onlineBadge printOnlineBadge">
                <PrintOnlineIcon />
                <span>Online</span>
              </div>
              <button
                onClick={(e) => {
                  handlePrintOnlineCardClick(
                    e,
                    identifier,
                    onlineEleRef,
                    currentEntityData,
                    V_ONLINE
                  );
                }}
                id={identifier}
                type="button"
                className="btn btn-link"
                disabled={feedListLoader}
              >
                {`${currentEntityData.entity_display_name} ${TOTAL_ARTICLES}(${
                  onlineDataCount ?? 0
                })`}
              </button>
              {/* Please work on this loader */}
              {feedListLoader ? <Loader /> : null}
            </div>
          </Sticky>
          <div className={`collapse ${activeClass}`}>
            <div className="card-body">
              <div className="inner-feed-container">
                {onlineFeedsList?.map((news, index) => {
                  if (!news) {
                    return null;
                  }
                  return (
                    <div class="innerFeedItem" ref={lastOnlineFeedItemElementRef}>
                      <SingleFeedItem
                        key={index}
                        isOnline
                        feed={news}
                        editionList={[]}
                        allArticleList={allArticlesDataSet}
                        singleNewsGroup={[news]}
                        onFeedSelect={onFeedSelect}
                        selectedFeeds={selectedFeeds}
                        updatedBulkTheme={updatedBulkTheme}
                        updatedBulkSentiment={updatedBulkSentiment}
                        updatedBulkFavourite={updatedBulkFavourite}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            {renderPrintOnlinePagination(isCardSelected, null, entityFeeds.total,onlineFeedsList.length)}
          </div>
        </div>
      );
    }
  };
  const tvFeeds = () => {
    const identifier = isTVIdentifier;
    const isCardSelected = isFeedGroupSelected(identifier);
    const isActive = activeKey === identifier;
    const activeClass = isActive ? "show" : "";

    if (tvData) {
      return (
        <div
          ref={tvEleRef}
          className={
            activeKey !== identifier
              ? "customAccordionRow card"
              : "customAccordionRow card active"
          }
        >
          <Sticky
            scrollElement=".accordionListWrap"
            boundaryElement=".customAccordionRow"
            style={{ position: "relative" }}
            hideOnBoundaryHit={false}
          >
            <div className={`card-header ${activeClass}`}>
              <label className="inputWrap">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    handleFeedGroupClick(isTVIdentifier);
                    onFeedSelect(
                      !isCardSelected,
                      currentData,
                      entityId,
                      entityName
                    );
                  }}
                  checked={isCardSelected}
                />
                <span className="checkmark"></span>
              </label>
              <button
                onClick={(e) => {
                  handleCardClick(e, identifier, tvEleRef, "", true);
                }}
                id={identifier}
                type="button"
                className="btn btn-link"
              >
                {`${entityName} (${entityFeeds.total || 0})`}
              </button>
            </div>
          </Sticky>
          <div className={`collapse ${activeClass}`}>
            <div className="card-body">
              <div className="inner-feed-container">
                {currentData &&
                  currentData.map((news, index) => {
                    news.entityId = entityId;
                    if (!news) {
                      return null;
                    } else {
                      return (
                        <SingleFeedItem
                          key={news.id}
                          feed={news}
                          selectedFeeds={selectedFeeds}
                          onFeedSelect={onFeedSelect}
                          allArticleList={allArticleList}
                          entityName={entityName}
                          forEmbedArticles={forEmbedArticles}
                          updatedBulkSentiment={updatedBulkSentiment}
                          updatedBulkFavourite={updatedBulkFavourite}
                          updatedBulkTheme={updatedBulkTheme}
                          clientId={clientId}
                          entityId={entityId}
                          onSingleFeedSelect={onSingleFeedSelect}
                          updateSelectedTagsToFeeds={updateSelectedTagsToFeeds}
                          isTV
                        />
                      );
                    }
                  })}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };
  const reportsData = () => {
    const identifier = isReportIdentifier;
    const isCardSelected = isFeedGroupSelected(identifier);
    const isActive = activeKey === identifier;
    const activeClass = isActive ? "show" : "";

    if (DownloadreportData) {
      return (
        <div ref={reportEleRef} className={"customAccordionRow card"}>
          <Sticky
            scrollElement=".accordionListWrap"
            boundaryElement=".customAccordionRow"
            style={{ position: "relative" }}
            hideOnBoundaryHit={false}
          >
            <div className={`card-header ${activeClass}`}>
              {`${entityName}`}
              <button
                onClick={(e) => {
                  handleCardClick(e, identifier, reportEleRef, url);
                }}
                id={identifier}
                type="button"
              >
                Download
              </button>
            </div>
          </Sticky>
        </div>
      );
    }
  };

  const ref = useRef();
  const lastSocialFeedItemElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (ref.current) ref.current.disconnect();
      ref.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreSocialFeeds) {
          setOffset(offset + 1);
        }
      });
      if (node) ref.current.observe(node);
    },
    [isLoading, hasMoreSocialFeeds]
  );

  const printRef = useRef();
  const lastPrintOnlineFeedItemElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (printRef.current) printRef.current.disconnect();
      printRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMorePrintOnlineFeeds) {
          setprintOffset(printOffset + PRINT_PERPAGE_LIMIT+(printOffset===0?1:0));
        }
      });
      if (node) printRef.current.observe(node);
    },
    [isLoading, hasMorePrintOnlineFeeds]
  );
  const onlineRef = useRef();
  const lastOnlineFeedItemElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (onlineRef.current) onlineRef.current.disconnect();
      onlineRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMorePrintOnlineFeeds) {
          setonlineOffset(onlineOffset + ONLINE_PERPAGE_LIMIT+(onlineOffset===0?1:0));
        }
      });
      if (node) onlineRef.current.observe(node);
    },
    [isLoading, hasMorePrintOnlineFeeds]
  );

  const socialFeeds = () => {
    const identifier = socialIdentifier;
    const isCardSelected = isFeedGroupSelected(identifier);
    const isActive = activeKey === identifier;
    const activeClass = isActive ? "show" : "";

    if (socialData) {
      return (
        <div
          ref={socialEleRef}
          className={
            activeKey !== identifier
              ? "customAccordionRow card"
              : "customAccordionRow card active"
          }
        >
          <Sticky
            scrollElement=".accordionListWrap"
            boundaryElement=".customAccordionRow"
            style={{ position: "relative" }}
            hideOnBoundaryHit={false}
          >
            <div className={`card-header ${activeClass}`}>
              <label className="inputWrap">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    handleCardClickSocialBlogCheckbox(
                      e,
                      identifier,
                      socialEleRef,
                      isCardSelected,
                      socialIdentifier,
                      entityId,
                      entityName,
                      "",
                      false
                    );
                  }}
                  checked={isCardSelected}
                />
                <span className="checkmark"></span>
              </label>
              <button
                onClick={(e) => {
                  handleCardClick(e, identifier, socialEleRef);
                }}
                id={identifier}
                type="button"
                className="btn btn-link"
              >
                {`${entityName} (${entityFeeds.total || 0})`}
              </button>
            </div>
          </Sticky>
          <div className={`collapse ${activeClass}`}>
            <div className="card-body">
              <div className="inner-feed-container">
                {currentData &&
                  currentData.map((news, index) => {
                    news.entityId = entityId;
                    if (!news) {
                      return null;
                    }
                    if (currentData.length === index + 1) {
                      return (
                        <>
                          <div ref={lastSocialFeedItemElementRef}>
                            <SingleSocialFeedItem
                              key={news.id}
                              feed={news}
                              selectedFeeds={selectedFeeds}
                              onFeedSelect={onFeedSelect}
                              allArticleList={allArticleList}
                              entityName={entityName}
                              forEmbedArticles={forEmbedArticles}
                              updatedBulkSentiment={updatedBulkSentiment}
                              updatedBulkFavourite={updatedBulkFavourite}
                              clientId={clientId}
                              entityId={entityId}
                              onSingleFeedSelect={onSingleFeedSelect}
                              updateSelectedTagsToFeeds={
                                updateSelectedTagsToFeeds
                              }
                              isyoutube={true}
                            />
                          </div>
                        </>
                      );
                    } else {
                      return (
                        <SingleSocialFeedItem
                          key={news.id}
                          feed={news}
                          selectedFeeds={selectedFeeds}
                          onFeedSelect={onFeedSelect}
                          allArticleList={allArticleList}
                          entityName={entityName}
                          forEmbedArticles={forEmbedArticles}
                          updatedBulkSentiment={updatedBulkSentiment}
                          updatedBulkFavourite={updatedBulkFavourite}
                          clientId={clientId}
                          entityId={entityId}
                          onSingleFeedSelect={onSingleFeedSelect}
                          updateSelectedTagsToFeeds={updateSelectedTagsToFeeds}
                          isyoutube={true}
                        />
                      );
                    }
                  })}
              </div>
            </div>
            {isActive &&
              renderPagination(isCardSelected, null, entityFeeds.total)}
          </div>
        </div>
      );
    }
  };

  const blogAndForumFeeds = () => {
    const identifier = blogsAndForumIdentifier;
    const isCardSelected = isFeedGroupSelected(identifier);
    const isActive = activeKey === identifier;
    const activeClass = isActive ? "show" : "";
    if (blogsAndForumData) {
      return (
        <div
          ref={blogsnForumEleRef}
          className={
            activeKey !== identifier
              ? "customAccordionRow card"
              : "customAccordionRow card active"
          }
        >
          <Sticky
            scrollElement=".accordionListWrap"
            boundaryElement=".customAccordionRow"
            style={{ position: "relative" }}
            hideOnBoundaryHit={false}
          >
            <div className={`card-header ${activeClass}`}>
              <label className="inputWrap">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    handleCardClickSocialBlogCheckbox(
                      e,
                      identifier,
                      blogsnForumEleRef,
                      isCardSelected,
                      blogsAndForumIdentifier,
                      entityId,
                      entityName,
                      type,
                      true
                    );
                  }}
                  checked={isCardSelected}
                />
                <span className="checkmark"></span>
              </label>
              <div className="badgeWrap">
                {isBlogsAndForum &&
                  (type == VERTICALS.V_BLOG ? (
                    <VerticalTag
                      key={VERTICALS.V_BLOG}
                      type={VERTICALS.V_BLOG}
                    />
                  ) : (
                    <VerticalTag
                      key={VERTICALS.V_FORUM}
                      type={VERTICALS.V_FORUM}
                    />
                  ))}
              </div>
              <button
                onClick={(e) => {
                  handleCardClick(e, identifier, blogsnForumEleRef);
                }}
                id={identifier}
                type="button"
                className="btn btn-link"
              >
                {`${entityName} (${entityFeeds.total || 0})`}
              </button>
            </div>
          </Sticky>
          <div className={`collapse ${activeClass}`}>
            <div className="card-body">
              <div className="inner-feed-container">
                {currentData &&
                  currentData.map((news, index) => {
                    news.entityId = entityId;
                    if (!news) {
                      return null;
                    }
                    return (
                      <BlogsAndForumFeedItem
                        key={news.id}
                        feed={news}
                        selectedFeeds={selectedFeeds}
                        onFeedSelect={onFeedSelect}
                        allArticleList={allArticleList}
                        entityName={entityName}
                        forEmbedArticles={forEmbedArticles}
                        updatedBulkSentiment={updatedBulkSentiment}
                        updatedBulkFavourite={updatedBulkFavourite}
                        clientId={clientId}
                        updateSelectedTagsToFeeds={updateSelectedTagsToFeeds}
                      />
                    );
                  })}
              </div>
            </div>
            {isActive &&
              renderPagination(isCardSelected, type, entityFeeds.total)}
          </div>
        </div>
      );
    }
  };
  const client_id = selectedClient && selectedClient.id;
  const eDate = getSocialApiDateFormat(toDate);
  const sDate = getSocialApiDateFormat(fromDate);

  const getEmbededFeedSearchUrl = () => {
    let url = unifiedEnvConfig.FETCH_MORE_SOCIAL_FEEDS;
    let tempUrl = `${url}?client_id=${client_id}&page=${offset}&perPage=${SOCIAL_PERPAGE_LIMIT}&searchParams[from_date]=${sDate}&searchParams[to_date]=${eDate}&searchParams[type]=${entityFeeds.type}&searchParams[topic_id]=${entityFeeds.entityId}`;
    const {
      embTonality,
      embLanguage,
      embChannelType,
      embCountry,
      embKeywords,
    } = embeddedArticleFilters;

    if (embChannelType) {
      if (Array.isArray(embChannelType)) {
        embChannelType.forEach((cType) => {
          tempUrl = `${tempUrl}&searchParams[channel_type][]=${cType}`;
        });
      } else {
        tempUrl = `${tempUrl}&searchParams[channel_type]=${embChannelType}`;
      }
    }
    if (embTonality) {
      if (Array.isArray(embTonality)) {
        embTonality.forEach((t) => {
          tempUrl = `${tempUrl}&tonalityFilter[]=${t}`;
        });
      } else {
        tempUrl = `${tempUrl}&tonalityFilter[]=${embTonality}`;
      }
    }
    if (selectedTaglist && selectedTaglist.length) {
      selectedTaglist.forEach((t) => {
        tempUrl = `${tempUrl}&tagFilter[]=${t === "Not Rated" ? null : t}`;
      });
    }
    if (embLanguage && embLanguage.length) {
      if (Array.isArray(embLanguage)) {
        embLanguage.forEach((l) => {
          let langId = getKeyByValue(LANGUAGE_CODES, l);
          tempUrl = `${tempUrl}&searchParams[language][]=${langId}`;
        });
      } else {
        let langId = getKeyByValue(LANGUAGE_CODES, embLanguage);
        if (langId) {
          tempUrl = `${tempUrl}&searchParams[language]=${langId}`;
        }
      }
    }
    if (embCountry) {
      tempUrl = `${tempUrl}&searchParams[country]=${embCountry}`;
    }
    if (embKeywords) {
      tempUrl = `${tempUrl}&searchParams[keyword]=${encodeURIComponent(
        embKeywords
      )}`;
    }
    return tempUrl;
  };

  const getViewMoreUrl = () => {
    if (forEmbedArticles) {
      return getEmbededFeedSearchUrl();
    }
    const {
      likesCount,
      dislikeCount,
      commentsCount,
      shareOrRetweetCount,
      viewsCount,
    } = countFilters || {};
    let url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS_BY_ENTITY;
    let clientId = client_id;
    //part of CP-110
    if (parentClientId !== clientId) clientId = parentClientId;
    let tempUrl = `${url}?topic_id=${entityFeeds.entityId}&client_id=${clientId}&page=${offset}&perPage=${SOCIAL_PAGE_PERPAGE_LIMIT}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}&searchParams[type]=${entityFeeds.type}&searchParams[topic_id][]=${entityFeeds.entityId}&searchParams[countflag]=0&searchParams[totalcount]=${entityFeeds.total||0}&profileAssociate=true`;

    if (isFavouriteChecked) {
      tempUrl = `${tempUrl}&favFilter=${isFavouriteChecked}`;
    }
    
    if (isMainstreammedia) {
      tempUrl = `${tempUrl}&searchParams[mainstreammedia]=1`;
    } 

    if (Array.isArray(channelType)) {
      channelType.forEach((cType) => {
        tempUrl = `${tempUrl}&searchParams[channel_type][]=${cType}`;
      });
    }
    if (tonality) {
      tempUrl = `${tempUrl}&tonalityFilter[]=${tonality}`;
    }
    if (language && language.length) {
      language.forEach((clanguage) => {
        tempUrl = `${tempUrl}&searchParams[lang][]=${clanguage}`;
      })
    }
    if (country && country.length) {
      country.forEach((ccountry) => {
        tempUrl = `${tempUrl}&searchParams[country][]=${ccountry}`;
      })
    }
    if (selectCity && selectCity.length) {
      tempUrl = `${tempUrl}&searchParams[city]=${selectCity}`;
    }
    if (commentsCount) {
      tempUrl = `${tempUrl}&searchParams[min_comments]=${commentsCount}`;
    }
    if (likesCount) {
      tempUrl = `${tempUrl}&searchParams[min_likes]=${likesCount}`;
    }
    if (shareOrRetweetCount) {
      tempUrl = `${tempUrl}&searchParams[min_shares]=${shareOrRetweetCount}`;
    }
    if (isSocial && showInfluencerPosts) {
      tempUrl = `${tempUrl}&searchParams[influencer_filter]=${true}`;
    }
    if (selectedTaglist && selectedTaglist.length) {
      selectedTaglist.forEach((t) => {
        tempUrl = `${tempUrl}&tagFilter[]=${t === "Not Rated" ? null : t}`;
      });
    }

    if (headline) {
      tempUrl = `${tempUrl}&headlineFilter=${headline}`;
    }
    if (keyword) {
      tempUrl = `${tempUrl}&keywordFilter=${keyword}`;
    }
    // TODO: to be done as part of CB-476
    // if (dislikeCount) {
    //   tempUrl = `${tempUrl}&searchParams[min_shares]=${dislikeCount}`;
    // }
    // if (viewsCount) {
    //   tempUrl = `${tempUrl}&searchParams[min_views]=${viewsCount}`;
    // }
    // if (reaction && reaction.length) {
    //   tempUrl = `${tempUrl}&searchParams[min_reactions]=${reaction}`;
    // }
    return tempUrl;
  };
  const handleMoreClick = () => {
    try {
      setIsLoading(true);
      httpGet(getViewMoreUrl())
        .then((response) => {
          const {
            data: {
              data,
              pagination: { page, pages },
            },
          } = response;
          if (data && page && pages) {
            const moreData = Object.values(data);
            const allData = [...currentData, ...moreData];
            setCurrentData(allData);
            setHasMoreSocialFeeds(moreData.length === (isSocial?SOCIAL_PAGE_PERPAGE_LIMIT:50));
            mergePaginatedFeedsToCurrentList(allData, entityId, type);
            setShowPagination(page != pages);
          }
        })
        .catch((error) => {
          console.log(error);
          setOffset(offset - 1);
        })
        .finally(() => setIsLoading(false));
    } catch (e) {
      setOffset(offset - 1);
    }
  };

  const renderPagination = (isCardSelected = false, type, totalFeeds, socialPage  = false) => {
    if (
      ((!socialPage && currentData &&
        currentData.length <= SOCIAL_PERPAGE_LIMIT &&
        totalFeeds &&
        totalFeeds <= SOCIAL_PERPAGE_LIMIT) || (socialPage && currentData &&
          currentData.length <= SOCIAL_PAGE_PERPAGE_LIMIT &&
          totalFeeds &&
          totalFeeds <= SOCIAL_PAGE_PERPAGE_LIMIT)) ||
      !showShowPagination
    ) {
      return null;
    }
    return (
      <div className="viewMoreBtnWrap">
        {
          isLoading ? <Loader /> : null
          // <Button
          //   className="btn btnBlue viewMoreBtn"
          //   onClick={() => {
          //     setOffset(offset + 1);
          //     setIsSelectAll(isCardSelected);
          //     setSelectedType && setSelectedType(type);
          //   }}
          // >
          //   View More
          // </Button>
        }
      </div>
    );
  };

  const renderPrintOnlinePagination = (isCardSelected = false, type, totalFeeds,articleData) => {
    if (
      ((articleData &&
        articleData <= SOCIAL_PERPAGE_LIMIT &&
        totalFeeds &&
        totalFeeds <= SOCIAL_PERPAGE_LIMIT)) ||
      !showShowPagination
    ) {
      return null;
    }
    return (
      <div className="viewMoreBtnWrap">
        {
          isLoading ? <Loader /> : null
          // <Button
          //   className="btn btnBlue viewMoreBtn"
          //   onClick={() => {
          //     setOffset(offset + 1);
          //     setIsSelectAll(isCardSelected);
          //     setSelectedType && setSelectedType(type);
          //   }}
          // >
          //   View More
          // </Button>
        }
      </div>
    );
  };

  return (
    <div>
      {isSocial && socialFeeds()}
      {isBlogsAndForum && blogAndForumFeeds()}
      {isDownloadreport && reportsData()}
      <>
        {((printFeedsList && printFeedsList.length) ||
          isBothSelected ||
          isPrintSelected) &&
          printFeeds()}
        {((onlineFeedsList && onlineFeedsList.length) ||
          isBothSelected ||
          isOnlineSelected) &&
          onlineFeeds()}
        {isTV && tvFeeds()}
      </>
    </div>
  );
}

TopicWiseNewsContainer.defaultProps = {
  setIsSelectAll: () => {},
};
